import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/AddUserToOrganization";

export function* addUserToOrganization(action: Actions.AddUserToOrganizationAction) {
    const { payload } = action;
    const { credentials, options, organizationId, userId } = payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.addUserToOrganization(userId, organizationId, options);
        yield put(Actions.addUserToOrganizationEnd(undefined, organizationId, result));
    } catch (e) {
        yield put(Actions.addUserToOrganizationEnd(e, organizationId));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchAddUserToOrganization() {
    yield takeEvery(Actions.ADD_USER_TO_ORGANIZATION, addUserToOrganization);
}
